import { API_BASE_URL } from '../client';

export const MILESTONE_ENDPOINTS = {
  MILESTONE_NODES: {
    LIST: `${API_BASE_URL}/MilestoneNode`,
    DETAIL: (id: number) => `${API_BASE_URL}/MilestoneNode/${id}`,
    CREATE: `${API_BASE_URL}/MilestoneNode`,
    UPDATE: (id: number) => `${API_BASE_URL}/MilestoneNode/${id}`,
    DELETE: (id: number) => `${API_BASE_URL}/MilestoneNode/${id}`,
  },
  TEMPLATES: {
    LIST: `${API_BASE_URL}/MilestoneTemplate`,
    DETAIL: (id: number) => `${API_BASE_URL}/MilestoneTemplate/${id}`,
    DETAIL_FULL: (id: number) => `${API_BASE_URL}/MilestoneTemplate/${id}/detail`,
    CREATE: `${API_BASE_URL}/MilestoneTemplate`,
    UPDATE: (id: number) => `${API_BASE_URL}/MilestoneTemplate/${id}`,
    DELETE: (id: number) => `${API_BASE_URL}/MilestoneTemplate/${id}`,
    UPDATE_OWNERS: (id: number) => `${API_BASE_URL}/MilestoneTemplate/${id}/owners`,
  },
} as const;
